/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availabilityRangeDataSchema = z.object({
  endDate: z.iso.date().nullish(),
  fridayDuration: z.int().min(0).max(86400),
  mondayDuration: z.int().min(0).max(86400),
  priority: z.string().min(0).max(100).nullish(),
  saturdayDuration: z.int().min(0).max(86400),
  startDate: z.iso.date().nullish(),
  sundayDuration: z.int().min(0).max(86400),
  thursdayDuration: z.int().min(0).max(86400),
  tuesdayDuration: z.int().min(0).max(86400),
  wednesdayDuration: z.int().min(0).max(86400),
});
